import { createReducer, on } from '@ngrx/store';

import { WorkSaveStatusActions } from './work-save-status.actions';
import { initialWorkSaveStatusState, workSaveStatusAdapter, WorkSaveStatusState } from './work-save-status.model';

export const workSaveStatusReducer = createReducer<WorkSaveStatusState>(
  initialWorkSaveStatusState,

  on(
    WorkSaveStatusActions.componentRegistered,
    (state, { id, component, feature }): WorkSaveStatusState =>
      workSaveStatusAdapter.addOne({ id, component, feature, status: null }, state)
  ),
  on(
    WorkSaveStatusActions.statusChanged,
    (state, { id, status }): WorkSaveStatusState => workSaveStatusAdapter.updateOne({ id, changes: { status } }, state)
  ),
  on(
    WorkSaveStatusActions.componentUnregistered,
    (state, { id }): WorkSaveStatusState => workSaveStatusAdapter.removeOne(id, state)
  )
);
